import { all } from 'redux-saga/effects'
import authSagas from './auth.sagas';
import contactsSagas from './contacts.sagas';
import profileSagas from './profile.sagas';
import accountRecovery from './accountRecovery.sagas';


export default function* rootSaga() {
  yield all([
    accountRecovery(),
    authSagas(),
    contactsSagas(),
    profileSagas(),
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js